// extracted by mini-css-extract-plugin
module.exports = {"projects":"projects_projects__215iG","projects__header":"projects_projects__header__3977b","projects__data":"projects_projects__data__3pno9"};